export default function ({ isSwitchOn }) {
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
            width="22px" height="20px" viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                fill={isSwitchOn ? "#c4c0c1" : "#f2416e"} stroke="none">
                <path d="M2463 5105 c-78 -22 -126 -49 -180 -103 -60 -60 -99 -138 -113 -222
                -13 -84 -14 -2012 0 -2093 14 -87 54 -167 113 -224 83 -80 165 -115 272 -116
                182 -2 334 112 386 288 12 42 14 217 14 1110 0 1184 6 1090 -71 1202 -91 133
                -271 200 -421 158z"/>
                <path d="M1085 4587 c-62 -21 -79 -32 -188 -126 -670 -577 -990 -1469 -841
                -2346 179 -1058 1027 -1904 2084 -2079 937 -155 1874 219 2449 979 265 349
                426 745 493 1210 17 120 17 522 -1 640 -97 654 -387 1193 -864 1601 -131 113
                -188 138 -287 131 -159 -11 -275 -134 -275 -292 0 -111 31 -162 172 -287 142
                -124 252 -249 348 -393 523 -783 415 -1815 -257 -2471 -207 -202 -438 -347
                -713 -447 -337 -124 -767 -142 -1133 -48 -237 61 -484 181 -687 334 -103 78
                -295 269 -372 372 -263 350 -395 746 -395 1180 0 314 65 591 202 865 123 247
                270 431 512 643 100 88 133 151 133 253 -1 118 -59 210 -168 265 -52 27 -155
                34 -212 16z"/>
            </g>
        </svg>
    );
}
